import { AnalyticsProvider } from './AnalyticsProvider';
import { buildSafePageLocation } from '../../utils/detailedResultsStorage';

export class SegmentProvider implements AnalyticsProvider {
  name = 'segment';
  private analytics: any;

  initialize(): void {
    this.loadSegmentScript();
  }

  private loadSegmentScript(): void {
    (function () {
      var analytics = (window.analytics = window.analytics || []) as any;
      if (!analytics.initialize)
        if (analytics.invoked)
          window.console &&
            console.error &&
            console.error('Segment snippet included twice.');
        else {
          analytics.invoked = !0;
          analytics.methods = [
            'trackSubmit',
            'trackClick',
            'trackLink',
            'trackForm',
            'pageview',
            'identify',
            'reset',
            'group',
            'track',
            'ready',
            'alias',
            'debug',
            'page',
            'screen',
            'once',
            'off',
            'on',
            'addSourceMiddleware',
            'addIntegrationMiddleware',
            'setAnonymousId',
            'addDestinationMiddleware',
            'register',
          ];
          analytics.factory = function (e: any) {
            return function () {
              var i = Array.prototype.slice.call(arguments);
              if (
                [
                  'track',
                  'screen',
                  'alias',
                  'group',
                  'page',
                  'identify',
                ].indexOf(e) > -1
              ) {
                var c = document.querySelector("link[rel='canonical']");
                i.push({
                  __t: 'bpc',
                  c: (c && c.getAttribute('href')) || void 0,
                  p: window.location.pathname,
                  u: window.location.href,
                  s: window.location.search,
                  t: document.title,
                  r: document.referrer,
                });
              }
              // Add safety check before unshift
              if (i && Array.isArray(i)) {
                i.unshift(e);
                analytics.push(i);
              } else {
                console.warn('Segment analytics: Invalid arguments array', i);
              }
              return analytics;
            };
          };
          for (var i = 0; i < analytics.methods.length; i++) {
            var key = analytics.methods[i];
            analytics[key] = analytics.factory(key);
          }
          analytics.load = function (key: any, i: any) {
            var t = document.createElement('script');
            t.type = 'text/javascript';
            t.async = !0;
            t.src =
              'https://cdn.segment.com/analytics.js/v1/' +
              key +
              '/analytics.min.js';
            var n = document.getElementsByTagName('script')[0];
            if (n && n.parentNode) {
              n.parentNode.insertBefore(t, n);
            }
            analytics._loadOptions = i;
          };
          analytics._writeKey = process.env.REACT_APP_SEGMENT_WRITE_KEY || '';
          analytics.app = 'jht-web-app';
          analytics.SNIPPET_VERSION = '5.2.0';
          analytics.load(process.env.REACT_APP_SEGMENT_WRITE_KEY || '');
          analytics.page();
        }
    })();
    this.analytics = (window as any).analytics;
  }

  track(event: string, properties?: Record<string, any>): void {
    if (this.analytics) {
      this.analytics.track(event, properties, {
        context: { page: { url: buildSafePageLocation() } },
      });
    }
  }

  identify(userId: string, traits?: Record<string, any>): void {
    if (this.analytics) {
      this.analytics.identify(userId, traits);
    }
  }

  page(name?: string, properties?: Record<string, any>): void {
    if (this.analytics) {
      this.analytics.page(name, {
        ...properties,
        url: buildSafePageLocation(),
      });
    }
  }
}
